(function () {
  var root = document.getElementById('rm-menu');
  if (!root || window.__runicMenu) return;
  window.__runicMenu = true;
  document.body.appendChild(root);

  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('rm-data').textContent) || {}; } catch (e) {}
  var S = cfg.i18n || {};
  var list = root.querySelector('.rm-list');
  var logo = root.querySelector('.rm-logo');
  var hoursEl = root.querySelector('.rm-hours');
  var statusEl = root.querySelector('.rm-status');
  var lastFocus = null, closeT = null, built = false;

  var CHEV = '<svg class="rm-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"></path></svg>';

  /* ---------- Metinler ---------- */
  Array.prototype.forEach.call(root.querySelectorAll('[data-rm-t]'), function (el) { el.textContent = S[el.getAttribute('data-rm-t')] || ''; });
  root.querySelector('.rm-close').setAttribute('aria-label', S.close || 'Close');
  root.querySelector('.rm-panel').setAttribute('aria-label', S.menu || 'Menu');

  /* ---------- Logo ---------- */
  var src = document.querySelector('.header__mobile-logo') || document.querySelector('.header__normal-logo') || document.querySelector('header img[src*="logo"], header a[href="/"] img');
  if (src && src.getAttribute('src')) {
    var im = document.createElement('img');
    im.src = src.currentSrc || src.getAttribute('src');
    im.alt = cfg.shop || '';
    logo.appendChild(im);
  } else {
    logo.textContent = cfg.shop || '';
  }

  /* ---------- Calisma saati (Istanbul) ---------- */
  function setStatus() {
    var on = false;
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var m = Number(p.hour) * 60 + Number(p.minute);
      on = ['Sat', 'Sun'].indexOf(p.weekday) < 0 && m >= 540 && m < 1170;
    } catch (e) {}
    hoursEl.classList.toggle('is-on', on);
    statusEl.textContent = on ? (S.on || '') : (S.off || '');
  }

  /* ---------- Kategorileri Kalles menusunden kur ---------- */
  function txt(a) {
    var c = a.cloneNode(true);
    Array.prototype.forEach.call(c.querySelectorAll('i, svg, .t4s-mb-nav__icon, .t4s-lb_nav_mb'), function (x) { x.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  }
  function samePath(href) {
    try { return new URL(href, location.href).pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, ''); } catch (e) { return false; }
  }
  function isCat(li) {
    return li.classList.contains('t4s-menu-item-has-children') &&
      !li.classList.contains('t4s-languages') && !li.classList.contains('t4s-currencies') &&
      !li.classList.contains('t4s-menu-item-btns') && !li.classList.contains('t4s-menu-item-infos') &&
      !li.classList.contains('t4s-menu-item-cat');
  }
  function addLink(box, a) {
    var l = document.createElement('a');
    l.className = 'rm-link';
    l.href = a.getAttribute('href');
    l.textContent = txt(a);
    if (samePath(l.href)) l.classList.add('is-current');
    box.appendChild(l);
    return l.classList.contains('is-current');
  }

  function makeCat(i, title, iconEl, href, fill) {
    var cat = document.createElement('li');
    cat.className = 'rm-cat';
    cat.style.animationDelay = (0.08 + i * 0.05) + 's';
    var row = document.createElement('button');
    row.type = 'button';
    row.className = 'rm-row';
    row.setAttribute('aria-pressed', 'false');
    var ico = document.createElement('span');
    ico.className = 'rm-ico';
    if (iconEl) ico.appendChild(iconEl.cloneNode(true));
    var name = document.createElement('span');
    name.className = 'rm-name';
    name.textContent = title;
    row.appendChild(ico);
    row.appendChild(name);
    row.insertAdjacentHTML('beforeend', CHEV);
    cat.appendChild(row);

    var box = document.createElement('div');
    box.className = 'rm-links';
    var current = fill(box);
    if (href && href !== '/' && href !== (cfg.root || '/')) {
      var all = document.createElement('a');
      all.className = 'rm-all';
      all.href = href;
      all.innerHTML = '<span></span>' + ARROW;
      all.firstChild.textContent = S.all || '';
      box.appendChild(all);
    }
    cat._box = box;
    cat._name = title;
    if (current || (href && href !== '/' && samePath(href))) cat.classList.add('is-current');
    list.appendChild(cat);
  }

  function build(src) {
    var items = Array.prototype.filter.call(src.children, isCat);
    if (!items.length) return false;
    list.innerHTML = '';
    var n = 0;
    items.forEach(function (li) {
      var top = li.querySelector(':scope > a');
      if (!top) return;
      var ul = li.querySelector(':scope > ul');
      var kids = ul ? Array.prototype.filter.call(ul.children, function (c) { return c.querySelector(':scope > a'); }) : [];
      var grouped = kids.length > 0 && kids.every(function (c) { var k = c.querySelector(':scope > ul'); return k && k.children.length; });
      if (grouped) {
        // Ornek: Ev Urunleri -> Mutfak ve Yasam ayri kategoriler olarak listelenir.
        kids.forEach(function (c) {
          var a = c.querySelector(':scope > a');
          makeCat(n++, txt(a), top.querySelector('i'), a.getAttribute('href'), function (box) {
            var cur = false;
            Array.prototype.forEach.call(c.querySelector(':scope > ul').children, function (k) {
              var ka = k.querySelector(':scope > a');
              if (ka && addLink(box, ka)) cur = true;
            });
            return cur;
          });
        });
        return;
      }
      makeCat(n++, txt(top), top.querySelector('i'), top.getAttribute('href'), function (box) {
        var cur = false;
        kids.forEach(function (c) {
          var a = c.querySelector(':scope > a');
          var sub = c.querySelector(':scope > ul');
          if (sub && sub.children.length) {
            var g = document.createElement('p');
            g.className = 'rm-group';
            g.textContent = txt(a);
            box.appendChild(g);
            Array.prototype.forEach.call(sub.children, function (k) {
              var ka = k.querySelector(':scope > a');
              if (ka && addLink(box, ka)) cur = true;
            });
          } else if (addLink(box, a)) cur = true;
        });
        return cur;
      });
    });
    built = true;
    setActive(defaultCat());
    return true;
  }

  function ensure() {
    if (built) return Promise.resolve();
    var src = document.getElementById('menu-mb__ul');
    if (src && build(src)) return Promise.resolve();
    var base = cfg.root || '/';
    if (base.slice(-1) !== '/') base += '/';
    return fetch(base + '?section_id=mb_nav').then(function (r) { return r.text(); }).then(function (h) {
      var d = new DOMParser().parseFromString(h, 'text/html');
      var u = d.getElementById('menu-mb__ul');
      if (u) build(u);
    }).catch(function () {});
  }

  /* ---------- Iki sutun: solda kategoriler, sagda alt kategoriler ---------- */
  var body = root.querySelector('.rm-body');
  var split = document.createElement('div');
  split.className = 'rm-split';
  list.parentNode.insertBefore(split, list);
  split.appendChild(list);
  var side = document.createElement('div');
  side.className = 'rm-side';
  side.setAttribute('aria-live', 'polite');
  split.appendChild(side);
  // Iletisim sabit durmasin: kaydirilan alanin en altina tasinir.
  var foot = root.querySelector('.rm-foot');
  if (foot) body.appendChild(foot);

  function setActive(cat) {
    if (!cat || !cat._box) return;
    Array.prototype.forEach.call(list.querySelectorAll('.rm-cat'), function (c) {
      var on = c === cat;
      c.classList.toggle('is-active', on);
      c.querySelector('.rm-row').setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var box = cat._box.cloneNode(true);
    Array.prototype.forEach.call(box.children, function (el, i) { el.style.animationDelay = Math.min(i, 14) * 0.025 + 's'; });
    side.innerHTML = '';
    side.appendChild(box);
  }
  function defaultCat() {
    return list.querySelector('.rm-cat.is-current') || list.querySelector('.rm-cat');
  }
  list.addEventListener('click', function (e) {
    var row = e.target.closest('.rm-row');
    if (row && row.parentNode._box && !row.parentNode.classList.contains('is-active')) setActive(row.parentNode);
  });

  /* ---------- Ac / kapat ---------- */
  // Mobilde header gorunurse menu onun altina yerlesir, header sabit kalir.
  function header() {
    var b = document.querySelector('.t4s-push-menu-btn');
    return b && (b.closest('.t4s-section-header') || b.closest('header'));
  }
  function dock() {
    var h = header(), bottom = 0;
    if (h && window.matchMedia('(max-width: 767px)').matches) bottom = Math.round(h.getBoundingClientRect().bottom);
    var on = bottom > 0 && bottom < window.innerHeight * 0.5;
    root.classList.toggle('is-docked', on);
    root.style.top = on ? bottom + 'px' : '';
    return on;
  }
  function open() {
    clearTimeout(closeT);
    setStatus();
    ensure();
    if (root.hidden) { lastFocus = document.activeElement; root.hidden = false; }
    var docked = dock();
    document.documentElement.classList.add('rm-lock');
    void root.offsetWidth;
    root.classList.add('is-open');
    if (!docked) {
      var x = root.querySelector('.rm-close');
      setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) {} }, 60);
    }
  }
  function close() {
    if (root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('rm-lock');
    closeT = setTimeout(function () { root.hidden = true; body.scrollTop = 0; setActive(defaultCat()); }, 460);
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
  }
  window.RunicMenu = { open: open, close: close };

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-rm-close]')) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) { e.preventDefault(); close(); }
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { root.classList.remove('is-open'); root.hidden = true; document.documentElement.classList.remove('rm-lock'); } });

  /* ---------- Hamburger ikonunu devral ---------- */
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-menu-drawer], .t4s-push-menu-btn, [data-rm-open]');
    if (!t) {
      // Menu acikken header'daki baska bir ikona (sepet, arama, logo) basilirsa menu kapanir, tiklama devam eder.
      var h = header();
      if (!root.hidden && root.classList.contains('is-open') && h && h.contains(e.target)) close();
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!root.hidden && root.classList.contains('is-open')) close(); else open();
  }, true);

  if ('requestIdleCallback' in window) requestIdleCallback(ensure); else setTimeout(ensure, 1200);
})();
